import React from 'react';

import { BaseContactLensDropdown } from '../Dropdown';
import { SELECT_POWER_MODAL_LIST } from '../constants';

export const SelectPowerDropdown = props => {
  return <BaseContactLensDropdown {...props} list={SELECT_POWER_MODAL_LIST} />;
};
